/* eslint-disable */
// material-dashboard-react-main/src/layouts/authorizedDeviceStatus/index.js

import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Card from "@mui/material/Card";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import AppSnackbar from "components/common/AppSnackbar";
import CircularProgress from "@mui/material/CircularProgress";

import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import AuthorizedDeviceService from "services/authorizedDeviceService";
import { filterApplyButtonSx } from "components/common/buttonStyles";

export default function AuthorizedDeviceStatus() {
  const navigate = useNavigate();
  const [status, setStatus] = useState(null);
  const [label, setLabel] = useState("");
  const [loading, setLoading] = useState(true);
  const [submitting, setSubmitting] = useState(false);
  const [snack, setSnack] = useState({ open: false, message: "", severity: "info" });

  const canRequestAuthorization = ["missing", "revoked"].includes(status?.status);
  const canGoHome = ["active", "admin_bypass"].includes(status?.status);

  const loadStatus = async () => {
    setLoading(true);
    try {
      const data = await AuthorizedDeviceService.getDeviceStatus();
      setStatus(data);
    } catch (error) {
      setSnack({
        open: true,
        message:
          error.response?.data?.message ||
          error.response?.data?.error ||
          "No se pudo consultar el estado del dispositivo.",
        severity: "error",
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadStatus();
  }, []);

  useEffect(() => {
    if (status?.status !== "pending") return undefined;

    const interval = setInterval(async () => {
      try {
        const data = await AuthorizedDeviceService.getDeviceStatus();
        setStatus(data);
      } catch (error) {
        // Mantener la solicitud pendiente visible si falla una consulta automática.
      }
    }, 15000);

    return () => clearInterval(interval);
  }, [status?.status]);

  const handleRequestAuthorization = async () => {
    setSubmitting(true);
    try {
      const data = await AuthorizedDeviceService.requestDeviceAuthorization(label);
      setSnack({
        open: true,
        message:
          data?.status === "active"
            ? "Este dispositivo ya está autorizado."
            : "Solicitud de autorización enviada.",
        severity: data?.status === "active" ? "success" : "info",
      });
      await loadStatus();
    } catch (error) {
      setSnack({
        open: true,
        message:
          error.response?.data?.message ||
          error.response?.data?.error ||
          "No se pudo solicitar autorización.",
        severity: "error",
      });
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={3} pb={3}>
        <Card sx={{ overflow: "visible" }}>
          <MDBox
            mx={{ xs: 1.5, sm: 2 }}
            mt={-3}
            py={{ xs: 2, sm: 2.5 }}
            px={{ xs: 2, sm: 3 }}
            variant="gradient"
            bgColor="info"
            borderRadius="lg"
            coloredShadow="info"
          >
            <MDTypography variant="h6" color="white">
              Solicitá acceso en este dispositivo
            </MDTypography>
          </MDBox>

          <MDBox px={{ xs: 2, sm: 3 }} py={3} display="flex" flexDirection="column" gap={2}>
            {loading && (
              <MDBox display="flex" alignItems="center" gap={1.5}>
                <CircularProgress size={20} />
                <MDTypography variant="body2">Consultando estado...</MDTypography>
              </MDBox>
            )}

            {!loading && status?.status === "pending" && (
              <MDTypography variant="body2" color="text">
                Tu solicitud está pendiente de aprobación.
              </MDTypography>
            )}

            {!loading && canGoHome && (
              <MDTypography variant="body2" color="text">
                Ya podés usar la app desde este dispositivo.
              </MDTypography>
            )}

            {!loading && canRequestAuthorization && (
              <MDBox display="flex" flexDirection="column" gap={2} sx={{ maxWidth: 440 }}>
                <MDTypography variant="body2" color="text">
                  Escribí un nombre para que el administrador reconozca este dispositivo.
                </MDTypography>
                <TextField
                  label="Nombre"
                  placeholder="Ej.: Tablet de la empresa"
                  value={label}
                  onChange={(event) => setLabel(event.target.value)}
                  size="small"
                  fullWidth
                  inputProps={{ maxLength: 120 }}
                />
                <Button
                  variant="contained"
                  color="info"
                  onClick={handleRequestAuthorization}
                  disabled={submitting || loading}
                  sx={{ ...filterApplyButtonSx, width: { xs: "100%", sm: "fit-content" } }}
                >
                  {submitting ? "Solicitando..." : "Solicitar acceso"}
                </Button>
              </MDBox>
            )}

            {!loading && canGoHome && (
              <Button
                variant="contained"
                color="info"
                onClick={() => navigate("/dashboard")}
                sx={{ ...filterApplyButtonSx, width: { xs: "100%", sm: "fit-content" } }}
              >
                Ir al inicio
              </Button>
            )}

            {!loading && !status?.status && (
              <MDTypography variant="body2" color="text">
                No se pudo consultar el acceso. Recargá la página para intentar de nuevo.
              </MDTypography>
            )}
          </MDBox>
        </Card>
      </MDBox>
      <Footer />
      <AppSnackbar
        open={snack.open}
        onClose={() => setSnack((prev) => ({ ...prev, open: false }))}
        severity={snack.severity}
        message={snack.message}
      />
    </DashboardLayout>
  );
}
